import { useAuthStore } from '@stores/auth'
import { useCustomerStore } from '@stores/me/customer'
import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'
import { useSettingsStore } from '@stores/settings'
import { useListsStore } from '@stores/lists'
import { useBookingStore } from '@stores/booking'
import { usePadStore } from '@stores/pad'
import { useProgressReportStore } from '@stores/progress-report'
import { useScheduleStore } from '@stores/schedule'
import { useCheckoutStore } from '@stores/checkout'
import { useAiSummarizeStore } from '@stores/ai-summarize'
import { useAssessmentResultStore } from '@stores/assessment-result'

interface LogOutOptions {
  navigate?: boolean
}

interface LogOutReturn {
  logout: (options?: LogOutOptions) => Promise<void>
}

export const useLogOut = (): LogOutReturn => {
  const authStore = useAuthStore()
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()
  const bookingStore = useBookingStore()
  const settingsStore = useSettingsStore()
  const listsStore = useListsStore()
  const padStore = usePadStore()
  const progressReportStore = useProgressReportStore()
  const scheduleStore = useScheduleStore()
  const checkoutStore = useCheckoutStore()
  const aiSummarizeStore = useAiSummarizeStore()
  const assessmentResultStore = useAssessmentResultStore()

  const resetKeyedStores = (): void => {
    disciplineStore.resetState()
    bookingStore.resetState()
    progressReportStore.resetState()
    scheduleStore.resetState()
    kidStore.resetState()
    checkoutStore.resetState()
    aiSummarizeStore.resetState()
    assessmentResultStore.resetState()
  }

  const logout = async (options?: LogOutOptions): Promise<void> => {
    const shouldNavigate = options?.navigate ?? true

    customerStore.clear()
    kidStore.clear()
    settingsStore.clear()
    listsStore.clear()
    padStore.clear()
    resetKeyedStores()

    if (!shouldNavigate) {
      authStore.reset()
      return
    }

    await authStore.logout()
  }

  return {
    logout,
  }
}
